import React from 'react';
import { useNavigate } from 'react-router-dom';

const Error401Page = () => {
    const nav = useNavigate();

    return (
        <div className="relative flex size-full min-h-screen flex-col bg-white">
            <div className="px-20 lg:px-40 xl:px-40 flex flex-1 justify-center py-5 font-sans">
                <div className="flex flex-col w-full max-w-2xl py-5 flex-1">
                    <div className="flex flex-col items-center justify-center gap-3 p-4">
                        <div className="text-center">
                            <p className="text-[#111218] tracking-light text-2xl sm:text-3xl lg:text-[32px] font-bold leading-tight m-0">
                                401 Unauthorized
                            </p>
                            <p className="text-[#5f678c] text-sm font-normal leading-normal mt-4">
                                You don't have permission to access this resource.
                            </p>
                        </div>
                    </div>
                    <div className="p-4 flex justify-center">
                        <button
                            className="flex min-w-[120px] max-w-[300px] cursor-pointer items-center justify-center overflow-hidden rounded-xl h-12 px-6 bg-gray-50 text-[#121317] border border-gray-300 text-sm font-bold leading-normal transition-colors duration-200 hover:bg-gray-200 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed w-full"
                            onClick={() => nav('/')}
                        >
                            Go to Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error401Page;
